module.exports = __webpack_public_path__ + "static/media/add.f1b0ca24.svg";